import { useSelector } from 'react-redux';

/**
 * Return the visible schedule sessions
 * (filtered items + always visible items)
 *
 * @deprecated [...].schedule.visible should not be used anymore and will be removed in later versions
 *
 * @param {number} eventId Event ID
 * @returns array
 */
export function useVisibleSchedule(eventId) {
    return useSelector((state) => state.events[eventId]?.schedule.visible);
}
